import { Outlet, Route, Routes } from "react-router-dom";

import DocumentViewer from "../pages/DocumentViewer";
import Home from "../pages/Home/Home";
import NotFound from "../pages/NotFound/NotFound";
import Review from "../pages/Review";
import { DOCUMENT_VIEWER_PATH, HOME_PATH, REVIEW_PATH } from "./paths";
import RequireAuth from "./RequireAuth";

function ProtectedLayout() {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route element={<ProtectedLayout />}>
        <Route path={HOME_PATH} element={<Home />} />
        <Route path={REVIEW_PATH} element={<Review />} />
        <Route path={DOCUMENT_VIEWER_PATH} element={<DocumentViewer />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
